import { useState } from 'react';
import { useNavigate } from 'react-router-dom';

import useGoBack from '@/hooks/useGoBack';
import useStateHandler from '@/hooks/useStateHandler';
import ContinueButton from '@/shared-components/buttons/components/ContinueButton';
import CriticalChangesPopup from '@/shared-components/forms/add-artwork/components/CriticalChangesPopup';
import { editArtwork as editArtworkHandler } from '@/shared-components/forms/add-artwork/submit-button/components/EditArtworkHandler';
import { hasCriticalChanges,validateArtworkFields } from '@/shared-components/forms/add-artwork/utils';

import './styles/EditArtwork.css';

// 🔑 NUEVA prop: initialState (la pasas desde AddArtworkForm)
export default function EditArtwork({ formState, setFormError, initialState }) {
  const { cacheHandler, stateHandler, state } = useStateHandler();
  const userType = state.user_session?.user_type;
  const userId = state.user_session?.user_id;
  const [loading, setLoading] = useState(false);
  const [criticalOpen, setCriticalOpen] = useState(false);
  const [criticalLoading, setCriticalLoading] = useState(false);
  const navigate = useNavigate();
  const goBackHandler = useGoBack("/");

  const validations = () => {
    setLoading(true);
    setFormError(null);
    const errors = validateArtworkFields(formState);
    if (errors.length > 0) {
      setFormError(errors);
      setLoading(false);
      return false;
    }
    return true;
  };

  /* ----- envío real ----- */
  const submitEdit = async () => {
    setLoading(true);
    setFormError(null);
    await editArtworkHandler({
      formState,
      setFormError,
      navigate,
      cacheHandler,
      goBackHandler,
      userType,
      onArtworkEdited: () => {
        stateHandler.set("temporalPopup", {
          text: "Artwork edited successfully!",
          type: "navbar-present",
        });
      },
      stateHandler,
      userId,
    });
    setLoading(false);
  };

  /* ----- click en Confirm Changes ----- */
  const onConfirmClick = (e) => {
    e.preventDefault();
    if (!validations()) return;

    // ¿hay cambios críticos?
    const critical = hasCriticalChanges(initialState.current, formState);
    if (critical) {
      setCriticalOpen(true);
      setLoading(false);
      return;
    }
    submitEdit();
  };

  /* ----- acciones del popup ----- */
  const handleSendReview = async () => {
    setCriticalLoading(true);
    await submitEdit();
    setCriticalLoading(false);
    setCriticalOpen(false);
  };

  const handleRevert = () => {
    goBackHandler();
  };

  return (
    <>
      <ContinueButton
        onClick={onConfirmClick}
        disabled={loading}
        loading={loading}
        className="edit-artwork-button"
      >
        Confirm Changes
      </ContinueButton>
      <CriticalChangesPopup
        open={criticalOpen}
        loading={criticalLoading}
        onSendReview={handleSendReview}
        onRevert={handleRevert}
        onClose={() => setCriticalOpen(false)}
        userType={userType}
      />
    </>
  );
}
